import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_FILES_LIST = createRequestTypes('GET_FILES_LIST');
export const getFilesList = {
  request: () => action(GET_FILES_LIST[REQUEST]),
  success: data => action(GET_FILES_LIST[SUCCESS], { data }),
  failure: error => action(GET_FILES_LIST[FAILURE], { error }),
};
